export const getEffectiveReasonRule = (reason, subReason) => {
  if (
    subReason &&
    (Array.isArray(subReason.effective_allowed_resolutions) ||
      subReason.effective_resolution_config)
  ) {
    return {
      ...reason,
      allowed_resolutions: subReason.effective_allowed_resolutions || [],
      resolution_config: subReason.effective_resolution_config || {},
    };
  }

  if (
    reason?.reason_mode === "reason_first" &&
    subReason &&
    subReason.inherits_parent_resolution === false
  ) {
    return {
      ...reason,
      allowed_resolutions: subReason.allowed_resolutions || [],
      resolution_config: subReason.resolution_config || {},
    };
  }

  if (
    Array.isArray(reason?.effective_allowed_resolutions) ||
    reason?.effective_resolution_config
  ) {
    return {
      ...reason,
      allowed_resolutions: reason.effective_allowed_resolutions || [],
      resolution_config: reason.effective_resolution_config || {},
    };
  }
  return reason || {};
};

export const getEffectiveResolutionConfig = (reason, subReason, resolution) =>
  getEffectiveReasonRule(reason, subReason)?.resolution_config?.[resolution] || {};
